import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowDown,
  faArrowUp,
  faC,
  faS,
  faD,
  faTable,
  faTrash,
  faDownload,
  faM,
  faH,
  faGem,
  faL,
  faO,
  faT,
} from "@fortawesome/free-solid-svg-icons";
import { exportToExcel } from "utils/excelUtils";
import { calculateTotals } from "utils/pricingUtils";
import PricingTableHead from "./PricingTableHead";
import PricingTableFooter from "./PricingTableFooter";
import PriceTableRow from "./PriceTableRow";
import LabourBreakupModal from "../LabourModal";
import currencyFormatter from "currency-formatter";
import Tooltip from "components/Event/ToolTip/ToolTip";
import { quotationLabourBreakup } from "api";
import "pages/Pricing/Pricing.css";
import { Images } from "./Images";

export const PricingTable = ({
  handleLotList,
  labourLoader,
  setDeletestoneDetails,
  handleReCalculateLabour,
  lotCodeValue,
  setLotCodeValue,
  lotCodeList,
  handleRHSRateChange,
  handleMaxCtsChange,
  handleDeleteClick,
  isClosing,
  handleLabourDelete,
  deletestoneDetails,
  handleChainStoneDelete,
  handleAddToRow
}) => {
  const [showLabourModal, setShowLabourModal] = useState(false);
  const [currentLabourDetails, setCurrentLabourDetails] = useState([]);
  const [lhsAmtTotal, setLhsAmtTotal] = useState(0);
  const [rhsAmtTotal, setRhsAmtTotal] = useState(0);
  const [labourDetailError, setLabourDetailError] = useState([]);
  const [clickedDetails, setClickedDetails] = useState(null);

  const handleLabourBreakup = async (details, priceDetailsId) => {
    if (details.labourBreakup.length <= 0) {
      try {
        const { data } = await quotationLabourBreakup({ priceDetailsId });

        if (data.status === 200 && data.message === "success") {
          setCurrentLabourDetails([...data.data.labourBreakup]);
          setShowLabourModal(true);
          setLhsAmtTotal(data.data.lhsAmtTotal);
          setRhsAmtTotal(data.data.rhsAmtTotal);
          setLabourDetailError(data);
        } else {
          setLabourDetailError(data);
        }
      } catch (err) {
        console.error(err);
      }
    } else {
      setCurrentLabourDetails(details.labourBreakup);
      setLhsAmtTotal(details.lhsAmtTotal);
      setRhsAmtTotal(details.rhsAmtTotal);
      setShowLabourModal(true);
      setLabourDetailError({ message: "success" });
    }
  };

  // Function to handle click event and set the clicked row's details
  const handleRowClick = (details) => {
    setClickedDetails(details);
  };

  return (
    <div>
      {deletestoneDetails.priceDetails &&
        deletestoneDetails.priceDetails.map((details, subIndex) => {
          const { totalLHSAmt, totalRHSAmt } = calculateTotals(
            details.stoneDetails,
            details
          );
          const uniqueId = `accordion-${details._id}`;
          let src = details.stoneDetails[0]?.url;
          return (
            <React.Fragment key={uniqueId}>
              <div>
                <div
                  key={details.id}
                  className={`px-2 pt-1 ${
                    isClosing && "closing"
                  } accordion  card-accordion `}
                  id={uniqueId}
                >
                  <div className="card p-0 m-0 rounded">
                    <div className="card-header" id={`heading-${uniqueId}`}>
                      <h2 className="mb-0">
                        <div className="row">
                          <div className="col">
                            <div
                              className="headWrap"
                              data-toggle="collapse"
                              data-target={`#collapse-${uniqueId}`}
                              aria-expanded={true}
                              aria-controls={`collapse-${uniqueId}`}
                            >
                              <div style={styles.stoneHeader}>
                                <h5 style={styles.styleNo}>
                                  {details.styleNo} - {details.jewelType}
                                </h5>

                                <h6 className="m-0">
                                  MCP:{" "}
                                  <span className="cpText">
                                    {currencyFormatter.format(details.mcp, {
                                      code: `${details.currency}`,
                                    })}
                                  </span>
                                </h6>
                                {}
                                <h6 className="m-0">
                                  SP:{" "}
                                  <span className="spText">
                                    {currencyFormatter.format(details.sp, {
                                      code: `${details.currency}`,
                                    })}
                                  </span>
                                </h6>
                                <h6 className="m-0">
                                  Margin:{" "}
                                  <span className="mgText">
                                    {/* {marginPercentage?.toFixed(3) + "%"} */}
                                    {details.marginPercentage?.toFixed(3) + "%"}
                                    {Indicator[details.marginPercentage > 0]}
                                  </span>
                                </h6>
                                {details.fromLot === "YES" && (
                                  <h6 className="m-0">
                                    <span className="lotText">
                                      <FontAwesomeIcon fade icon={faL} />
                                      <FontAwesomeIcon fade icon={faO} />
                                      <FontAwesomeIcon fade icon={faT} />
                                    </span>
                                  </h6>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="totals_commodity">
                            <h6>
                              {details.diamondTotalWeight !== undefined &&
                              details.diamondTotalPc !== undefined &&
                              details.diamondTotalWeight !== 0 &&
                              details.diamondTotalPc !== 0 ? (
                                <>
                                  <FontAwesomeIcon
                                    icon={faD}
                                    className="alphColor"
                                  />{" "}
                                  :&nbsp;
                                  {details.diamondTotalWeight.toFixed(2) || 0}/
                                  {details.diamondTotalPc}{" "}
                                  <span>(cts/pcs)</span>
                                </>
                              ) : null}
                            </h6>
                            <h6>
                              {details.colorStoneTotalWeight !== undefined &&
                              details.colorStoneTotalPc !== undefined &&
                              details.colorStoneTotalWeight !== 0 &&
                              details.colorStoneTotalPc !== 0 ? (
                                <>
                                  <FontAwesomeIcon
                                    icon={faC}
                                    className="alphColor"
                                  />{" "}
                                  <FontAwesomeIcon
                                    icon={faS}
                                    className="alphColor"
                                  />{" "}
                                  :&nbsp;
                                  {details.colorStoneTotalWeight.toFixed(2) ||
                                    0}
                                  /{details.colorStoneTotalPc}{" "}
                                  <span>(cts/pcs)</span>
                                </>
                              ) : null}
                            </h6>
                            <h6>
                              {details.metalTotalWeight !== 0 &&
                              details.metalTotalWeight !== undefined ? (
                                <>
                                  <FontAwesomeIcon
                                    icon={faM}
                                    className="alphColor"
                                  />{" "}
                                  :&nbsp;
                                  {details.metalTotalWeight.toFixed(2) ||
                                    0}{" "}
                                  <span>(wt)</span>
                                </>
                              ) : null}
                            </h6>

                            <h6>
                              {details.chainTotalWeight !== 0 &&
                              details.chainTotalWeight !== undefined ? (
                                <>
                                  <FontAwesomeIcon
                                    icon={faC}
                                    className="alphColor"
                                  />{" "}
                                  <FontAwesomeIcon
                                    icon={faH}
                                    className="alphColor"
                                  />{" "}
                                  :&nbsp;
                                  {details.chainTotalWeight} <span>(wt)</span>
                                </>
                              ) : null}
                            </h6>
                          </div>
                          <Tooltip
                            className="custom-tooltip-container"
                            text="Tooltip content"
                            details={details}
                          >
                            <FontAwesomeIcon
                              icon={faGem}
                              fade
                              size="2xs"
                              className="text-white ml-2"
                            />
                          </Tooltip>
                          <ActionBtn
                            deleteAction={() =>
                              handleDeleteClick(deletestoneDetails, details)
                            }
                            labourAction={() => {
                              handleLabourBreakup(details, details._id);
                              handleRowClick(details);
                            }}
                            exportAction={() =>
                              exportToExcel(
                                deletestoneDetails.priceDetails,
                                details.styleNo
                              )
                            } // Call the exportToExcel function
                          />
                        </div>
                      </h2>
                    </div>
                    <div
                      id={`collapse-${uniqueId}`}
                      className="collapse"
                      aria-labelledby={`heading-${uniqueId}`}
                      data-parent={`#${uniqueId}`}
                    >
                      <div className="card-pricing-body">
                        <table key={`${subIndex}`}>
                          <tbody>
                            <tr key={subIndex}>
                              <td style={{ width: "150px" }}>
                                <div variant="primary" className="img-tag">
                                  <Images
                                    src={src}
                                    alt={"ImageDescription"}
                                    width={"225px"}
                                  />
                                </div>
                              </td>
                              <td>
                                <div className="smartTable-tableContainer stoneCardWrap">
                                  <table className="smartTable-table table position-relative">
                                    <PricingTableHead  />
                                    <tbody>
                                      {details.stoneDetails.map(
                                        (stoneDetails, subIndex) => (
                                          <>
                                            <PriceTableRow
                                              key={subIndex}
                                              setDeletestoneDetails={
                                                setDeletestoneDetails
                                              }
                                              handleLotList={handleLotList}
                                              setLotCodeValue={setLotCodeValue}
                                              lotCodeValue={lotCodeValue}
                                              lotCodeList={lotCodeList}
                                              stoneDetails={stoneDetails}
                                              subIndex={subIndex}
                                              deletestoneDetails={
                                                deletestoneDetails
                                              }
                                              handleRHSRateChange={
                                                handleRHSRateChange
                                              }
                                              handleMaxCtsChange={
                                                handleMaxCtsChange
                                              }
                                              details={details}
                                              handleAddToRow={handleAddToRow}
                                              handleChainStoneDelete={
                                                handleChainStoneDelete
                                              }
                                            />
                                          </>
                                        )
                                      )}
                                    </tbody>
                                    <PricingTableFooter
                                      details={details}
                                      totalLHSAmt={totalLHSAmt}
                                      totalRHSAmt={totalRHSAmt}
                                    />
                                  </table>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <LabourBreakupModal
                key={details._id} // Use a unique identifier as the key
                handleReCalculateLabour={handleReCalculateLabour}
                details={clickedDetails}
                deletestoneDetails={deletestoneDetails}
                showLabourModal={showLabourModal}
                currentLabourDetails={currentLabourDetails}
                lhsAmtTotal={lhsAmtTotal}
                setLhsAmtTotal={setLhsAmtTotal}
                setRhsAmtTotal={setRhsAmtTotal}
                rhsAmtTotal={rhsAmtTotal}
                handleLabourDelete={handleLabourDelete}
                labourDetailError={labourDetailError}
                labourLoader={labourLoader}
              />
            </React.Fragment>
          );
        })}
    </div>
  );
};

const ActionBtn = ({ deleteAction, labourAction, exportAction }) => (
  <div className="col-auto">
    <FontAwesomeIcon
      type="button"
      data-toggle="modal"
      data-target="#exampleModal1"
      className="ml-1 text-white"
      icon={faTable}
      title="Show Labour Details"
      size="2xs"
      onClick={labourAction}
    />

    <FontAwesomeIcon
      type="button"
      data-toggle="modal"
      title="Delete"
      data-target="#exampleModal"
      className="ml-3 text-white"
      icon={faTrash}
      size="2xs"
      onClick={deleteAction}
    />

    <FontAwesomeIcon
      type="button"
      title="Download Excel"
      className="ml-3 text-white"
      icon={faDownload}
      size="2xs"
      onClick={exportAction}
    />

    {/* <Table2
      type="button"
      data-toggle="modal"
      data-target="#exampleModal1"
      className="ml-1 text-white"
      title="Show Labour Details"
      onClick={labourAction}
      size={22}
    />

    <Trash2
      type="button"
      data-toggle="modal"
      title="Delete"
      data-target="#exampleModal"
      className="ml-3 text-white"
      size={22}
      onClick={deleteAction}
    />

    <Download
      type="button"
      title="Download Excel"
      className="ml-3 text-white"
      size={22}
      onClick={exportAction}
    /> */}
  </div>
);

const Indicator = {
  true: <FontAwesomeIcon icon={faArrowUp} className="px-2 text-success" />,
  false: <FontAwesomeIcon icon={faArrowDown} className="px-2 text-danger" />,
};

const styles = {
  stoneHeader: {
    display: "flex",
    flexDirection: "row",
    gap: 20,
    alignItems: "center",
    marginTop: "5px",
  },
  styleNo: {
    margin: 0,
    color: "#FFE345",
  },
};
